import { render, staticRenderFns } from "./MessagesDialog.vue?vue&type=template&id=dae3efac&"
import script from "./MessagesDialog.vue?vue&type=script&lang=js&"
export * from "./MessagesDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports